const createMarkup = (value: any) => {
  return { __html: value };
};

export const renderHtml = (value: any) => {
  return {
    dangerouslySetInnerHTML: createMarkup(value)
  };
};

export const flatMap = (array: any, fn: any) => {
  let result: any = [];

  for (let i = 0; i < array.length; i++) {
    const mapping = fn(array[i], i);
    result = result.concat(mapping);
  }
  return result;
};
